
import React from "react";
import { Breadcrumb, Button, Col, FloatButton, Input, Modal, Row, Select, Typography, message } from "antd";
import { Link, Navigate } from "react-router-dom";

import { IoAddOutline, IoArrowBack, IoEye, IoPencil, IoReturnUpBackOutline, IoTrash, IoTrashOutline } from "react-icons/io5";
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { POST_API, POST_CATCH, getToken, titleWeb } from "../../services/hello-api";

// COMPONENTS
import Table from '../../components/Table';

class LogsList extends React.Component {

    state = {
        _navigate: false,
        _loading: true,
        _map: false,
        _map_data: [],
        _params: window.location.href.split('/'),
        _type: this.props.type === 'list' ? 'Lista' : 'Lixeira',
        // TABLE
        table_load: true,
        table_column: [],
        table_data: [],
        table_search: '',
        table_pagination: {
            current: 1,
            total: 0,
            limit: 10
        },
        table_sorter: null,
        table_select: [],
        table_filter: { ACCOUNT_ID: '*', CREDENTIAL_ID: '*', TABLE: '*', FUNCTION: '*', DATE_START: '', DATE_END: '' },
        filters: { ACCOUNT_ID: [], CREDENTIAL_ID: [], TABLE: [], FUNCTION: [] }
    }

    back = "/dashboard/configuracoes/logs";

    componentDidMount = () => {
        titleWeb('Logs')
        this.onFilters()
        this.onRenderColumns().then(() => this.onRenderData())
    }

    onFilters = () => {
        POST_API('/logs/filters.php', { token: getToken() }).then(rs => rs.json()).then(res => {
            if (res.return) {
                this.setState({filters: res.data})
            } else {
                message.error({ content: res.msg, key: 'screen' })
            }
        }).catch(() => POST_CATCH())
    }
    
    // LOAD DATA
    onRenderData = () => {
        this.setState({table_load: true })
        var filter = this.state.table_filter;
        setTimeout(async () => {
            POST_API('/logs/search.php', { token: getToken(), pagination: JSON.stringify(this.state.table_pagination), filter: JSON.stringify(filter), sorter: JSON.stringify(this.state.table_sorter), search: this.state.table_search, type: this.props.type }).then(rs => rs.json()).then(res => {
                if (res.return) {
                    this.setState({
                        table_data: res.data,
                        table_pagination: {
                            ...this.state.table_pagination,
                            total: res.summary.QTDE
                        }
                    })
                } else {
                    message.error({ content: res.msg, key: 'screen' })
                }
            }).catch(() => POST_CATCH()).finally(() => this.setState({table_load: false }))
        }, 500);
    }

    // FUNCTION TABLE
    onRenderColumns = async () => {
        
        this.setState({
            table_column: [
                { title: 'Data/Hora', width: 160, align: 'center', dataIndex: 'DATETIME_INSERT_FORMAT', key: '_logs.DATETIME_INSERT', sorter: { compare: (a,b) => null }, showSorterTooltip: false },
                { title: 'Agência', align: 'center', dataIndex: 'ACCOUNT_NAME', key: 'account.NAME', sorter: { compare: (a,b) => null }, showSorterTooltip: false },
                { title: 'Usuário', align: 'center', dataIndex: 'CREDENTIAL_NAME', key: 'credential.NAME', sorter: { compare: (a,b) => null }, showSorterTooltip: false },
                { title: 'Tabela', align: 'center', dataIndex: 'TABLE_NAME', key: '_logs.`TABLE`', sorter: { compare: (a,b) => null }, showSorterTooltip: false },
                { title: 'Função', align: 'center', dataIndex: 'FUNCTION_NAME', key: '_logs.`FUNCTION`', sorter: { compare: (a,b) => null }, showSorterTooltip: false },
                { title: 'Ações', key: 'action', width: 60, render: (text, record) => (
                    <Row gutter={[4,4]} className="table__actions">
                        <Col><Button onClick={() => Modal.info({content: record.SQL})} className="table__btn table__btn_view" title='Visualizar' type="primary" shape="circle" size='small'><IoEye size={14} /></Button></Col>
                    </Row>
                )},
            ]
        })
    }

    onTableChange = (pagination, filters, sorter, extra) => {
        this.setState({
            table_sorter: sorter
        })
        this.onRenderData()
    }

    onPaginationChange = (page, size) => {
        this.setState({
            table_pagination: {
                ...this.state.table_pagination,
                current: page,
                limit: size
            },
        })
        this.onRenderData()
    }

    onSearchChange = (e) => {
        this.setState({
            table_search: e.target.value
        })
        this.onRenderData()
    }

    onSelect = (selectedRowKeys, selectedRows) => {
        this.setState({table_select: selectedRows})
    };

    onChangePage = () => {
        this.setState({table_data: [], _type: this.props.type !== 'list' ? 'Lista' : 'Lixeira'})
        this.onRenderData()
    }

    render = () => {

        const routes = [
            {title: <Link to="/dashboard/configuracoes"><Typography className="page-bread">Configurações</Typography></Link>},
            {title: <Link to={this.back} onClick={this.onChangePage}><Typography className="page-bread">Logs</Typography></Link>},
            {title: <Typography className="page-bread active">{this.state._type}</Typography>},
        ]
        
        if (this.state._navigate) {
            return (<Navigate to={'/dashboard'} />)
        }

        return (
            <Row>
                <Col xs={24} md={0}>
                    <Breadcrumb items={routes} className="bread-page" />
                </Col>
                <Col xs={0} md={24} className="page-header">
                    <Row className="table__row_table" gutter={[8,8]}>
                        <Col span={18}>
                            <Breadcrumb items={routes} />
                        </Col>
                    </Row>
                </Col>
                <Col span={24} className="page-content">
                    <Row className="table__row_table" gutter={[8,8]} style={{marginBottom: 10}} align={'bottom'}>
                        <Col xs={24} md={16}>
                            <Typography className="label_filter">Agência</Typography>
                            <Select style={{width: '100%'}} value={this.state.table_filter.ACCOUNT_ID} onChange={(v) => this.setState({ table_filter: { ...this.state.table_filter, ACCOUNT_ID: v } })}>
                                <Select.Option value="*">Todos</Select.Option>
                                { this.state.filters.ACCOUNT_ID.map( (v, i) => <Select.Option key={i} value={v.ID}>{v.NAME}</Select.Option> ) }
                            </Select>
                        </Col>
                        <Col xs={24} md={8}>
                            <Typography className="label_filter">Usuário</Typography>
                            <Select style={{width: '100%'}} value={this.state.table_filter.CREDENTIAL_ID} onChange={(v) => this.setState({ table_filter: { ...this.state.table_filter, CREDENTIAL_ID: v } })}>
                                <Select.Option value="*">Todos</Select.Option>
                                { this.state.filters.CREDENTIAL_ID.map( (v, i) => <Select.Option key={i} value={v.ID}>{v.NAME}</Select.Option> ) }
                            </Select>
                        </Col>
                        <Col xs={12} md={4}>
                            <Typography className="label_filter">Data (Início)</Typography>
                            <Input type="date" value={this.state.table_filter.DATE_START} onChange={(v) => this.setState({ table_filter: { ...this.state.table_filter, DATE_START: v.target.value } })} />
                        </Col>
                        <Col xs={12} md={4}>
                            <Typography className="label_filter">Data (Final)</Typography>
                            <Input type="date" value={this.state.table_filter.DATE_END} onChange={(v) => this.setState({ table_filter: { ...this.state.table_filter, DATE_END: v.target.value } })} />
                        </Col>
                        <Col xs={24} md={6}>
                            <Typography className="label_filter">Tabela</Typography>
                            <Select style={{width: '100%'}} value={this.state.table_filter.TABLE} onChange={(v) => this.setState({ table_filter: { ...this.state.table_filter, TABLE: v } })}>
                                <Select.Option value="*">Todos</Select.Option>
                                { this.state.filters.TABLE.map( (v, i) => <Select.Option key={i} value={v.ID}>{v.NAME}</Select.Option> ) }
                            </Select>
                        </Col>
                        <Col xs={24} md={4}>
                            <Typography className="label_filter">Função</Typography>
                            <Select style={{width: '100%'}} value={this.state.table_filter.FUNCTION} onChange={(v) => this.setState({ table_filter: { ...this.state.table_filter, FUNCTION: v } })}>
                                <Select.Option value="*">Todos</Select.Option>
                                { this.state.filters.FUNCTION.map( (v, i) => <Select.Option key={i} value={v.ID}>{v.NAME}</Select.Option> ) }
                            </Select>
                        </Col>
                        <Col xs={24} md={6}>
                            <Button shape="round" block type="primary" onClick={this.onRenderData}>Filtrar</Button>
                        </Col>
                    </Row>
                    <Table
                        _onAction={this.onAction}
                        _columns={this.state.table_column}
                        _data={this.state.table_data}
                        _pagination={this.state.table_pagination}
                        _loading={this.state.table_load}
                        _onChangeTable={this.onTableChange}
                        _onChangePagination={this.onPaginationChange}
                        _onChangeSearch={this.onSearchChange}
                        _search={this.state.table_search}
                    />
                </Col>
                
            </Row>
        )

    }

}

export default LogsList;